import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['status', 'editor']

  connect() { this.savedValue = this.editorTarget.value }

  disconnect() { clearTimeout(this.timer) }

  changed() {
    clearTimeout(this.timer)
    if (this.editorTarget.value === this.savedValue) return
    this.statusTarget.textContent = 'Modifications non enregistrées'
    this.timer = setTimeout(() => this.save(), 700)
  }

  async save(event) {
    if (event) event.preventDefault()
    clearTimeout(this.timer)
    if (this.saving) { this.saveAgain = true; return }
    this.saving = true
    const value = this.editorTarget.value
    this.statusTarget.textContent = 'Enregistrement…'
    try {
      const response = await fetch(this.element.action, {
        method: 'POST', credentials: 'same-origin', body: new FormData(this.element),
        headers: { Accept: 'application/json', 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
      })
      if (!response.ok || response.redirected) throw new Error('Save failed')
      const result = await response.json()
      if (!result.saved) throw new Error('Save failed')
      this.savedValue = value
      this.statusTarget.textContent = 'Notes enregistrées'
    } catch (_) {
      this.statusTarget.textContent = 'Échec de l’enregistrement. Cliquez sur « Enregistrer mes notes » pour réessayer.'
    } finally {
      this.saving = false
      if (this.saveAgain) { this.saveAgain = false; this.save() }
    }
  }
}
